<template>
  <div class="w-full">
    <h4 class="custom-title custom-color-gray font-medium mb-4">
      {{
        $t('message.publishDocuments.configGenericPublish.inputSector.title')
      }}
    </h4>
    <MultiSelect
      ref="inputSector"
      class="border-zt-dark-300 rounded border"
      :disabled="isDisabled"
      :placeholder="
        $t('message.publishDocuments.configGenericPublish.inputSector.label')
      "
      :value="sectorsSelected"
      :options="sectors"
      :multiple="true"
      :internal-search="true"
      :searchable="true"
      :close-on-select="false"
      :clear-on-select="true"
      :preserve-search="true"
      :show-labels="false"
      :show-no-options="false"
      @input="setSelected"
      @open="inputSearch"
      @close="inputSearch"
      data-vs-select="select-sector-generic"
    >
      <template slot="selection" slot-scope="{ values, isOpen, remove }">
        <div
          v-for="(option, index) in values"
          :key="index"
          v-if="index < 3"
          class="custom-chip font-normal inline-block vertical-align: middle max-w-full"
        >
          <div
            v-if="hasOption(option)"
            class="main-bg h-full flex rounded pl-3 pr-3 mb-2 mr-3 items-center"
          >
            <div class="chip-text pr-2">
              <p class="whitespace-no-wrap truncate capitalize">
                {{ toLower(option) }}
              </p>
            </div>
            <button
              class="focus:outline-none"
              @click="remove(option)"
              data-vs-button="remove"
            >
              <zt-icon name="close-rounded" />
            </button>
          </div>
        </div>
        <div
          v-if="values.length > 3"
          class="custom-chip chip-auto font-normal inline-block vertical-align: middle max-w-full"
        >
          <div
            class="main-bg h-full flex rounded pl-3 pr-3 mb-2 mr-3 items-center"
          >
            <div>
              <p class="whitespace-no-wrap truncate capitalize">
                {{ getTotalRest() }}
              </p>
            </div>
          </div>
        </div>
      </template>
      <template slot="noResult">
        <span>{{
          $t(
            'message.publishDocuments.configGenericPublish.inputSector.noResult'
          )
        }}</span>
      </template>
    </MultiSelect>
    <span class="text-zt-danger absolute pt-1" v-show="errorText">
      {{ errorText }}
    </span>
    <div v-if="hasSelected">
      <button
        class="text-zt-danger flex items-center border-none mt-4"
        @click="setSelected([])"
        data-vs-button="select-sector-generic-clear"
      >
        <zt-icon name="trash-outline" />
        <span class="ml-2">
          {{
            $t(
              'message.publishDocuments.configGenericPublish.inputSector.clear'
            )
          }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import MultiSelect from 'vue-multiselect'
export default {
  name: 'InputSector',
  inject: ['statePublish'],
  components: {
    MultiSelect
  },
  props: {
    sectors: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      sectorsSelected: [],
      errorText: '',
      isDisabled: true
    }
  },
  computed: {
    hasSelected() {
      return this.sectorsSelected.length > 0
    }
  },
  watch: {
    sectors(newArray) {
      this.isDisabled = !newArray.length
    }
  },
  mounted() {
    this.inputSearch()
  },
  methods: {
    setSelected(e) {
      this.sectorsSelected = e
      this.statePublish.sectors = this.sectorsSelected
      if (!this.sectorsSelected.length) {
        this.errorText = this.$t(
          'message.publishDocuments.configGenericPublish.inputSector.required'
        )
      } else {
        this.errorText = ''
      }
    },
    inputSearch() {
      const {
        $refs: { inputSector }
      } = this
      const search = inputSector.$refs.search
      if (inputSector.isOpen && !search.classList.contains('is-open')) {
        search.classList.add('is-open')
      } else {
        search.classList.remove('is-open')
      }
      const list = inputSector.$refs.list
      if (this.sectors.length && this.sectors.length < 5) {
        const firtOption = list.querySelector('li:first-child')
        const bbox = firtOption.getBoundingClientRect()
        list.style.minHeight = bbox.height * this.sectors.length + 'px'
      } else {
        list.style.minHeight = '300px'
      }
    },
    toLower(option) {
      if (typeof option === 'string') return option.toLowerCase()
      return option
    },
    hasOption(option) {
      return this.sectorsSelected.indexOf(option) <= 2
    },
    getTotalRest() {
      const [, , , ...rest] = this.sectorsSelected
      return `+${rest.length}`
    },
    onReset() {
      this.sectorsSelected = []
      this.statePublish.sectors = []
      this.errorText = ''
    }
  }
}
</script>

<style scoped lang="scss">
.custom-color-gray {
  color: #575757;
}
::v-deep {
  .zt-radiobutton {
    label {
      padding-top: 4px;
    }
    i {
      font-size: 1.5rem;
      line-height: 1;
    }
  }
  .multiselect {
    box-sizing: border-box;
    border-color: #969696 !important;
    border-radius: 0.375em !important;
    height: 51px !important;
  }
  .multiselect--above .multiselect__content-wrapper {
    bottom: 110%;
    border-bottom: 1px solid #969696;
  }
  .multiselect__content-wrapper {
    border-radius: 0 0 0.375em 0.375em !important;
    border-color: #969696;
    top: 100px;
    left: -1px;
    width: calc(100% + 1px) !important;
  }
  .multiselect__content-wrapper::-webkit-scrollbar-track {
    background-color: #c4c4c4;
  }
  .multiselect__content-wrapper::-webkit-scrollbar {
    width: 0.625rem;
  }
  .multiselect__content-wrapper::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: #888888;
  }
  .multiselect__spinner {
    right: 3px;
    width: 38px;
    height: 45px;
    &:before,
    &:after {
      border-color: #6200ee transparent transparent;
    }
  }
  .multiselect__tags {
    border: none;
    padding: 8px 38px 0 10px !important;
    border-radius: 0.375em !important;
    display: block !important;

    input {
      top: 52px;
      width: calc(100% + 1px) !important;
      position: absolute;
      padding: 0;
      display: none;
      height: 50px;
      left: -1px;
      border: solid 1px #969696;
      border-bottom: none;
      border-radius: 0.375em 0.375em 0 0;
      background: #f5f5f5;
    }

    input.is-open {
      display: block !important;
    }
  }
  .multiselect__select {
    padding-left: 16px;
  }
  .multiselect__option {
    padding-left: 2rem;
  }
  .multiselect__option--group {
    background: transparent;
    font-weight: bold;
    padding: 1rem;
  }
  .multiselect__option--selected,
  .multiselect__option--highlight {
    background-color: #e7e8ff !important;
    color: #707070;
    font-weight: normal;
  }
  .multiselect__select {
    top: 50%;
    margin-top: -19px;
    &:before {
      border-color: rgba(109, 109, 109, 1) transparent transparent;
    }
  }
  .multiselect__input {
    padding-left: 10px !important;
    color: #2d2d2d;
  }
  .multiselect__option.multiselect__option--selected {
    display: none;
  }
}

.custom-chip {
  width: 28%;
  font-size: 14px;
  line-height: 1;
  color: #261c77;
  font-weight: 400;
  .main-bg {
    background: #a7a0d1;
    height: 32px;
  }
  .chip-text {
    width: calc(100% - 16px);
  }
  button {
    font-size: 16px;
    color: #261c77;
  }
}
.chip-auto {
  width: auto !important;
}
.border-danger {
  border-color: #f16b6c !important;
}
</style>
